<template>
  <div class="task-view">
      <div class="notice">
          <span>完成以下游戏中任务，可以额外在此页面上获得限时奖励，欢迎老朋友回归，梦梦等着你！</span>
          <span class="reflash u-btn" @click="task_reflash()" v-if="login"><span class="icon"></span>刷新</span>
      </div>

      <div class="task-list" v-if="ready">
          <ul>
              <li v-for="(item,n) in task_info" :key="'t-' + n">
                  <h6><p>{{ item.title }}</p></h6>
                  <div class="reward-list">
                    <ul>
                        <li v-for="(r,index) in item.reward" :key="'r-' + index">
                            <p class="tag">{{item.max[index]}}</p>
                            <div class="status">
                                <div class="status-on" v-if="item.detail[index].isCompleted"></div>
                            </div>
                            <div class="item" 
                            @click="$item_tips(r.giftId + '_' + r.sendNum)"
                            @mouseover="$tips_on($event,r.giftId + '_' + r.sendNum)"
                            @mouseleave="$tips_off()"                                
                            >
                                <img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/icon/' + r.giftId + '_' + r.sendNum + '.jpg'" v-if="r.sendNum > 1">
                                <img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/icon/' + r.giftId + '.jpg'" v-if="r.sendNum == 1">                              
                            </div>
                            <p class="item-name">{{ r.giftName }}</p>
                        </li>
                    </ul>                      
                  </div>

                  <div class="u-btn apply" @click="apply_task(item.id,item)" v-if="item.detail.filter(function(e){ return e.isSubmit==false && e.isCompleted == true}).length"></div>
                  <div class="u-btn apply dismiss" v-else></div>
              </li>
          </ul>

          <div class="icon-arrow"></div>

          <div class="ticket-info">
              <div class="container">
                  <h6><p>幸运抽奖券</p></h6>
                  <div class="info">
                      <p>每完成{{ taskPos }}任</p>
                      <p>一个节点小任务即可</p>
                      <p>获得幸运抽奖券</p>
                      <p><b>{{ ticket_total() }}/12</b></p>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'task-return-view',
  data () {
    return {
      ready : true,
      task_info : [
          {
              title : '每日达成120活跃任务次数',
              max : ['3次','8次','15次'],
              reward : ['1','2','3'],
              id : '2',
              no : ['d01','d02','d03'],
              detail :[{
                rate : 0,
                isCompleted : false,
                isSubmit : false,                  
              },{
                rate : 0,
                isCompleted : false,
                isSubmit : false,                  
              },{
                rate : 0,
                isCompleted : false,
                isSubmit : false,                  
              }],
              ticket_num : [1,2,3],
          },
          {
              title : '匹配胜利竞技/出征游戏局数',
              max : ['胜利2局','胜利5局','胜利8局'],
              reward : ['1','2','3'],
              id : '101',
              no : ['j01','j02','j03'],
              detail :[{
                rate : 0,
                isCompleted : false,
                isSubmit : false,                  
              },{
                rate : 0,
                isCompleted : false,
                isSubmit : false,                  
              },{
                rate : 0,
                isCompleted : false,
                isSubmit : false,                  
              }],
              ticket_num : [1,2,3],
          },                 
      ],
      reward_list : [],
      gift_apply : 0,
      completed : 0,
      taskPos : this.$global.deviceType == 'pc'?'左侧':'上面',     
    }
  },
  props : {
    ua : {
        default : ()=>{},
    },
    login : {
        default : 0,
    },   
  },
  created (){
      if(this.login && this.ua.areaId)this.task_render();
      this.get_task_info();
  },
  methods :{
    task_render (){
        var _this = this;
        _this.$axios.get(_this.$global.ajax_url_map.task_info,{
            params: {
                utype : 1,
                gid : 4,
            }
        })
        .then(res => {
            if(res.data.code == 0){
                if(!res.data.data.length)return;
                for(var i = 0;i< _this.task_info.length;i++){
                    var ele = _this.task_info[i];
                    for(var k = 0;k < ele.no.length;k++){
                        var temp = res.data.data.filter(function(e){
                            return e.taskNo == _this.task_info[i].no[k];
                        });

                        _this.task_info[i].detail[k].isCompleted = temp[0].isCompleted;
                        _this.task_info[i].detail[k].isSubmit = temp[0].isSubmit;
                        _this.task_info[i].detail[k].rate = temp[0].rate;
                    }
                }
            }
            else{
                _this.$toast('任务模块:' + res.data.message);
            }
        });
    },
    apply_task (id,data){
        var _this = this;

        if(!_this.login)return this.$mslogin.open();
        if(!_this.ua.areaId)return this.$bind();

        _this.$axios.post(_this.$global.ajax_url_map.apply_gift,{
            id : id,
        })
        .then(res => {
            if(res.data.code == 0){
                //TODO
                _this.$toast('领取成功');
                _this.task_render();
            }
            else{
                _this.$toast(res.data.message);
            }
        });
    },
    get_task_info(){
    var _this = this;
    var orderList = ['d01','d02','d03','j01','j02','j03']
        _this.$axios.get(_this.$global.ajax_url_map.task_detail,{
            params: {
                type : 4,
            }
        })
        .then(res => {
            if(res.data.code == 0){
                //TODO
                _this.ready = true;
                //_this.return_gift = res.data.data[0].giftList;
                for(var i = 0;i < res.data.data.length;i++){
                    var the_list = res.data.data.filter(function(e){ return e.taskNo == orderList[i] })[0]
                    _this.reward_list.push(the_list.giftList.filter(function(e){ return e.giftId != 'j001'})[0]);
                }

                _this.task_info[0].reward = _this.reward_list.slice(0, 3);
                _this.task_info[1].reward = _this.reward_list.slice(3, 6);
            }
            else{
                _this.$toast('任务信息模块:' + res.data.message);
            }
        });          
    },
    ticket_total(){
        var _this = this;
        var total = 0;
        for(var i = 0;i< _this.task_info.length;i++){
            var ele = _this.task_info[i];
            for(var k = 0;k < ele.detail.length;k++){
                if(ele.detail[k].isCompleted){
                    var num =  ele.ticket_num[k];
                    total += num;
                }
            }
        }
        return total;       
    },
    task_reflash(){
        var _this = this;
        this.$axios.post(_this.$global.ajax_url_map.reflash)
        .then(res => {
            _this.$toast('刷新成功~');
            if(res.data.code == 0 && res.data.data){
                _this.task_render();
            }
        })
    },                       
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.reflash{
    color: #daa250;
    text-decoration: underline;
}

.reflash .icon{
    display: inline-block;
    width: 23px;
    height: 19px;
    margin: 0 10px;
    background-image: url(../images/icon-reflash.png);
    vertical-align: sub;
}

@media screen and (min-device-width: 1025px){
    .notice{
        font-size: 14px;
        color: #fdf0d5;
        text-align: center;
    }

    .reflash{
        display: inline-block;
        padding-left: 15px;
    }

    .reflash:hover{
        color: #f3bb69;
    }    

    .reflash:hover .icon{
        background-image: url(../images/icon-reflash_hover.png);
    }

    .task-list{
        display: flex;
        align-items: center;
        margin-top: 40px;
    }

    .task-list>ul{
        display: flex;
        justify-content: space-between;       
    }

    .task-list>ul>li{
        width: 312px;
        height: 354px;
        margin-right: 28px;
        font-size: 14px;
        color: #5c483c;
        text-align: center;
        background-image: url(../images/bg-task-item-2.png);
    }

    .task-list li h6{
        padding-top: 22px;
        margin-bottom: 25px;
        font-size: 18px;
        font-weight: 700;
        color: #ffeec4;       
    }

    .task-list .reward-list{
        width: 305px;
        margin: 55px 0 0 -5px;
        background-image: url(../images/bg-task-list_r.png);
        background-position: top center;
        background-repeat: no-repeat;       
    }

    .task-list .reward-list ul{
        position: relative;
        top: -35px;
        display: flex;
        justify-content: space-between;
        margin: 0 10px 0 30px;
    }

    .task-list .tag{
        margin-bottom: 5px;
        color: #a79079;
    }

    .task-list .status{
        position: relative;
        width: 28px;
        height: 29px;
        margin: 0 auto 25px;
        background-image: url(../images/bg-f-wait.png);
    }
    
    .status .status-on{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 50px;
        height: 34px;
        background-image: url(../images/bg-get.png);
        transform: translate(-52%,-60%);        
    }

    .task-list .reward-list .item{
        width: 83px;
        height: 80px;
        margin: 0 auto;
        background-image: url(../images/bg-item.png);        
    }

    .item-name{
        width: 90px;
    }
    
    .ticket-info{
        width: 250px;
        height: 347px;
        background-image: url(../images/bg-ticket.png);
    }

    .task-list .u-btn.apply{
        width: 127px;
        height: 41px;
        margin: -10px auto 0;
        background-image: url(../images/btn-apply_task.png);
    }

    .task-list .u-btn.apply:hover{
        background-image: url(../images/btn-apply_task_hover.png);
    }

    /* todo btn dismiss */
    .icon-arrow{
        width: 42px;
        height: 63px;
        margin: 0 25px 0 0;
        background-image: url(../images/icon-arrow_2.png);
    }

    .ticket-info{
        text-align: center;
    }

    .ticket-info h6{
        padding-top: 22px;
        margin-bottom: 33px;
        font-size: 18px;
        font-weight: 700;
        color: #ffeec4;        
    }

    .ticket-info .info{
        line-height: 1.6;
        color: #5c483c;
    }

    .ticket-info .info b{
        color: #a2332f;
    }
}

@media screen and (max-device-width: 1024px){
    .notice{
        position: relative;
        margin: 36px auto;
        padding-right: 100px;
        font-size: 24px;
        color: #fdf0d5;
    }

    .notice .reflash{
        position: absolute;
        top: 22px;
        right: 0;   
    }

    .reflash .icon{
        width: 40px;
        height: 33px;
        background-image: url(../images/m/icon-reflash.png);          
    }    
    
    .task-list>ul>li{
        position: relative;
        width: 673px;
        height: 446px;
        margin: 0 auto 15px;
        padding-top: 32px;
        padding-left: 80px;
        font-size: 24px;
        color: #5c483c;
        text-align: center;
        background-image: url(../images/m/bg-task-item-r.png);
        box-sizing: border-box;
    }

    .task-list li h6{
        position: absolute;
        left: 0;
        top: 0;
        width: 79px;
        height: 100%;
        font-size: 26px;
        font-weight: 700;
        color: #ffeec4;       
    }

    .task-list li h6 p{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 28px;
        line-height: 1;
        transform: translate(-50%,-50%);
    }
    
    .task-list li>.task-content{
        padding: 0 45px;
    }    

    .task-list .reward-list{
        width: 451px;
        margin: 55px auto -5px;
        background-image: url(../images/m/bg-task-list-r.png);
        background-position: top center;
        background-repeat: no-repeat;       
    }

    .task-list .reward-list ul{
        position: relative;
        top: -50px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
    }

    .task-list .tag{
        margin-bottom: 5px;
        color: #a79079;
    }

    .task-list .status{
        position: relative;
        width: 42px;
        height: 42px;
        margin: 0 auto 25px;
        background-image: url(../images/m/icon-off.png);
    }
    
    .status .status-on{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 72px;
        height: 50px;
        background-image: url(../images/m/icon-check.png);
        transform: translate(-52%,-60%);        
    }    

    .task-list .reward-list .item{
        width: 124px;
        height: 124px;
        margin: 0 auto;
        background-image: url(../images/m/bg-item-2.png);       
    }

    .item-name{
        width: 124px;
        margin-top: 12px;
        font-size: 24px;
        color: #5c483c;
        text-align: center;        
    }
    
    .ticket-info{
        position: relative;
        width: 673px;
        height: 279px;
        margin: 0 auto;
        background-image: url(../images/m/bg-ticket.png);
    }

    .ticket-info h6{
        position: absolute;
        left: 0;
        top: 0;
        width: 79px;
        height: 100%;
        font-size: 26px;
        font-weight: 700;
        color: #ffeec4;       
    }

    .ticket-info h6 p{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 28px;
        line-height: 1;
        transform: translate(-50%,-50%);
    }

    .ticket-info .info{
        margin-left: 305px;
        margin-right: 55px;
        padding-top: 52px;
        line-height: 1.6;
        color: #5c483c;
        text-align: center;
    }

    .ticket-info .info b{
        color: #a2332f;
    }    
        
    .task-list .u-btn.apply{
        position: absolute;
        bottom: 20px;
        right: 196px;
        width: 218px;
        height: 65px;
        background-image: url(../images/m/btn-apply.png);
    }    
}


</style>



// WEBPACK FOOTER //
// src/components/task.return.vue